import { Navigate, useParams, useSearchParams } from 'react-router-dom'
import { Column } from 'src/shared/components/Semantic/all'
import { buildGuidedAssistantPath } from 'src/routes/paths'
import { isRequestExploreMode } from '../requestNavParams'
import { RequestWorkspace } from './components/RequestWorkspace'

export const RequestPage = () => {
  const { public_id } = useParams<{ public_id: string }>()
  const [searchParams] = useSearchParams()

  if (public_id && isRequestExploreMode(searchParams)) {
    return <Navigate to={buildGuidedAssistantPath(public_id)} replace />
  }

  return (
    <Column className="flex h-full min-h-0 flex-col overflow-hidden">
      <RequestWorkspace publicId={public_id} />
    </Column>
  )
}

/** @deprecated Use RequestPage */
export const OrderPage = RequestPage
